import MeasurementsView from "components/MeasurementsView";
import HelpFloatingButtonV2 from "components/HelpFloatingButtonV2";

function ManageLoads() {
  return (
    <>
      <HelpFloatingButtonV2 helpScreen="loads" />
      <MeasurementsView initialSide="actual" />
    </>
  );
}

export default ManageLoads;
